import { useMemo } from 'react';

import { getModuleCodeFromSegment } from '@/features/header/consts/search';
import { useLocation } from 'react-router';

export const useRouteModuleCode = (): string => {
  const { pathname } = useLocation();

  return useMemo(() => {
    const firstSegment = pathname.split('/').find(Boolean);
    if (firstSegment === undefined) {
      return '';
    }
    return getModuleCodeFromSegment(firstSegment.toLowerCase());
  }, [pathname]);
};
